import React, { useEffect } from "react";
import styled from "styled-components";
import Button from "~/components-shared/Button";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useDispatch, useSelector } from "react-redux";
import { StatusStateEnum } from "~/types/enums";
import Modal from "~/components-shared/Modal";
import toastsActionCreators from "~/store/toasts/actions";
import { Alert } from "~/components-shared";
import manageCompanySelectors from "~/store/manageCompanies/selectors";
import manageCompaniesActionCreators from "~/store/manageCompanies/actions";
import ManageCompanyForm from "~/forms/ManageCompanyForm";
import manageCompanySchema from "~/forms/ManageCompanyForm/manageCompanySchema";
const Sticky = styled.div`
  position: sticky;
  top: 0;
  z-index: 2;
`;
const Form = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  height: 100%;
`;
const ManageCompanyCreateModal = () => {
  const {
    t
  } = useTranslation();
  const action = useSelector(manageCompanySelectors.getAction);
  const status = useSelector(manageCompanySelectors.getStatusByCompany("+"));
  const error = useSelector(manageCompanySelectors.getErrorByCompany("+"));
  const dispatch = useDispatch();
  const defaultValues = {
    name: "",
    description: "",
    context: "",
    url: "",
    employeeCount: 0,
    weight: 0,
    emailDomains: "",
    authorities: [],
    settings: {
      isPaidPlan: false,
      recommendedIntegrations: [],
      preferredIntegrations: [],
      sendSlackStatusReport: false,
      hideSlackPrivateMessages: false,
      privateSlackChannelApprovals: true,
      ssoAuthentication: false,
      memberBlacklist: [],
      costPerVolume: {},
      costAiAssistantCap: 0,
      costUsageCap: 0,
      eventBlacklist: [],
      topicEventDirectMapping: [],
      detectionThresholds: {}
    }
  };
  const {
    handleSubmit,
    control,
    watch,
    setValue,
    setError,
    reset
  } = useForm({
    resolver: yupResolver(manageCompanySchema),
    defaultValues
  });
  useEffect(() => {
    if (!action) {
      reset(defaultValues);
    }
  }, [action]);
  const onSubmit = handleSubmit(data => {
    dispatch(manageCompaniesActionCreators.createStarted(data, _ref => {
      let {
        data: newCompany
      } = _ref;
      if (newCompany) {
        dispatch(toastsActionCreators.pushed({
          severity: "success",
          message: t("ManageCompanyCreateModal.companyCreated", {
            name: newCompany.name
          }),
          timeout: 10000
        }));
        reset(defaultValues);
      }
    }));
  });
  const onCancel = () => {
    dispatch(manageCompaniesActionCreators.actionChanged(null, null));
  };
  return /*#__PURE__*/React.createElement(Modal.Body, {
    title: t("ManageCompanyCreateModal.createCompany"),
    onClose: onCancel,
    fullWidth: true,
    fullHeight: true,
    maxWidth: "640px"
  }, /*#__PURE__*/React.createElement(Form, {
    onSubmit: onSubmit
  }, /*#__PURE__*/React.createElement(Modal.Content, null, error && /*#__PURE__*/React.createElement(Sticky, null, /*#__PURE__*/React.createElement(Alert, {
    severity: "danger",
    s: {
      mb: 3
    },
    fullWidth: true
  }, error)), /*#__PURE__*/React.createElement(ManageCompanyForm, {
    company: null,
    control: control,
    watch: watch,
    setValue: setValue,
    setError: setError
  })), /*#__PURE__*/React.createElement(Modal.Actions, null, /*#__PURE__*/React.createElement(Button, {
    color: "transparent",
    s: {
      px: 8
    },
    onClick: onCancel,
    rounded: true
  }, t("common.actions.cancel")), /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    type: "submit",
    maxWidth: "230px",
    onClick: onSubmit,
    s: {
      ml: 2
    },
    loading: status === StatusStateEnum.LOADING,
    fullWidth: true,
    rounded: true
  }, t("ManageCompanyCreateModal.saveCompany")))));
};
export default ManageCompanyCreateModal;